import { atom } from "recoil";
import { CoreConfigurationData } from "../models/generated/graphql";

export interface CoreConfigState {
	key: string;
	default: CoreConfigurationData;
}

const initialValueCoreConfig: CoreConfigState = {
	key: "coreConfigData",
	default: { coverageApprovalTypeIds: [] },
};

export const coreConfig = atom(initialValueCoreConfig);
